import { ElementRef } from '@angular/core';
import { CommonSetting } from '../../../commons/kymw00/common-setting';
import { FuncPermission, LoginUserInfoModel } from '../kymw1000/vo/login-user-info.model';
import { GetInitTopModel, PermissionModel } from './vo/get-init-top.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW00Model } from 'src/app/commons/kymw00/kymw00.model';

/**
 * メインメニュー　モデルクラス
 *
 * @export KYMW1001Model
 * @class KYMW1001Model
 */
export class KYMW1001Model {

  public permissionList: PermissionModel[] = null;

  public loginUserInfo: GetInitTopModel = new GetInitTopModel();

  // パスワード有効期限日数
  public pwdLimitDay: string = null;
  /** ユーザID統合管理システムパスワード変更画面URL */
  public idTogoChangePasswordUrl: string = null;

  // 画面項目の活性/非活性の制御用に追加
  private readonly FULL_CONTROL: number = Number(2);
  // トップ画面から起動した機能の機能IDを保持する
  public topFuncID: string = null;
  // トップ画面から起動した機能の画面モード(更新可能/閲覧のみ)を保持する
  public topFuncReadOnlyMode: boolean = null;
  // 各画面の
  public formReadOnlyMode: Map<string, boolean> = new Map();

  /** 機能ID→機能オブジェクトとなるマップ. */
  public funcPermissionMap: Map<string, PermissionModel> = new Map();

  /**
   * 起動した機能の機能ID、画面モード(更新可能/閲覧のみ)の格納
   *
   * @param {string} funcID 機能ID
   * @returns {string}
   * @memberof KYMW1001Model
   */
  public setScreenModeOnNowFunc(funcID: string): string {
    this.topFuncID = funcID;
    const funcList: PermissionModel[] = this.permissionList;
    let i: number;
    let mode: string;

    if(funcList) {
      for (i = 0; i < funcList.length; i++) {
        if (funcList[i].FuncID === this.topFuncID) {
          if (funcList[i].EnableMode === this.FULL_CONTROL.toString()) {
            this.topFuncReadOnlyMode = false;
            mode = 'false';
            this.formReadOnlyMode.set('KYMW1002', false);
          } else {
            this.topFuncReadOnlyMode = true;
            mode = 'true';
            this.formReadOnlyMode.set('KYMW1002', true);
          }
          break;
        }
      }
      return mode;
    }
  }

  /**
   * バイヤー判別用メソッド
   */
  public isBuyer(): boolean {
    const buyerCodeList = this.loginUserInfo.BuyerCodeList;
    if(PlessViewUtilsSub.isEmptyArray(buyerCodeList)) {
      // バイヤーではない
      return false;
    }else {
      // バイヤー
      return true;
    }
  }

  /**
   * 取引先判別用メソッド
   */
  public isSupplier(): boolean {
    return this.loginUserInfo.AssociatedUserType === KYMW00Model.ASSOCIATED_USER_TYPE_SUPPLIER;
  }

  /**
   * 企画支援会社判別用メソッド
   */
  public isPlanningSupport(): boolean {
    return this.loginUserInfo.PlanningSupportFlg === KYMW00Model.PLANNING_SUPPORT_TRUE;
  }
}
